import { groupRoomsByFloor, DEMO_LEVEL_LABEL } from "./helpers";
import { SITE_CONDITION_TYPES } from "../../lib/romEngine";

const SITE_LABEL = Object.fromEntries(SITE_CONDITION_TYPES.map((t) => [t.v, t.label]));

/* Read-only room-by-room scope summary — grouped by floor/area so the office
 * can key it straight into Xactimate. Shared by the ROM editor, the PDF and
 * the adjuster/client share link so all three always agree. */
export function RoomScopeSummary({ rooms, siteConditions }) {
    const groups = groupRoomsByFloor(rooms);
    const conditions = (siteConditions || []).map((c) => (typeof c === "string" ? { text: c, type: "other" } : c)).filter((c) => c && c.text);
    if (!groups.length && !conditions.length) return null;
    const totalSqft = groups.reduce((s, g) => s + g.sqft, 0);
    const hasWallScope = groups.some((g) => g.rooms.some((r) => r.wallScope));

    return (
        <div data-testid="room-scope-summary" data-pdf-section>
            <h3 data-pdf-unit="header" className="font-display font-bold uppercase text-xs tracking-wider mt-4 mb-2">
                Scope summary · for Xactimate line entry
            </h3>
            {groups.length > 0 && (
                <table className="rom-table mb-1" data-testid="scope-summary-table">
                    <thead><tr><th>Floor / area</th><th>Room</th><th className="numeric">Sq ft</th><th>Cut height / demo level</th><th>Wall scope</th><th>Materials affected</th></tr></thead>
                    <tbody>
                        {groups.map((g) => g.rooms.map((r, i) => (
                            <tr data-pdf-unit="row" key={`${g.floor}-${i}`}>
                                <td>{g.floor}</td>
                                <td>{r.name || "—"}</td>
                                <td className="numeric">{Number(r.sqft || 0).toLocaleString()}</td>
                                <td>{DEMO_LEVEL_LABEL[r.demoLevel || ""] || r.demoLevel}</td>
                                <td>{r.wallScope || "All walls"}</td>
                                <td className="text-[var(--rom-text-2)]">{r.materials || "—"}</td>
                            </tr>
                        )))}
                    </tbody>
                    <tfoot><tr data-pdf-unit="row"><td colSpan={2}>Total</td><td className="numeric font-bold">{totalSqft.toLocaleString()}</td><td colSpan={3}></td></tr></tfoot>
                </table>
            )}
            {hasWallScope && (
                <div data-pdf-unit="row" className="text-[10px] text-[var(--rom-text-3)] italic mb-3" data-testid="wall-scope-disclaimer">
                    Wall scope is descriptive only — pricing is not yet adjusted for partial-wall damage.
                </div>
            )}
            {conditions.length > 0 && (
                <div className="text-xs" data-testid="scope-summary-site-conditions">
                    <div className="font-semibold text-[var(--rom-text)] mb-1">Site conditions</div>
                    <ul className="list-disc ml-5 space-y-0.5 text-[var(--rom-text-2)]">
                        {conditions.map((c, i) => (
                            <li key={i}>{c.type && c.type !== "other" ? <><b className="text-[var(--rom-text)]">{SITE_LABEL[c.type] || c.type}</b> — </> : null}{c.text}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
